import {QueryResult, ListDef} from 'olympe'

/**
 * @param {*} source
 * @return {Object}
 */
export const getAsArray = source => {
    let list = [];
    if (Array.isArray(source)) {
        list = source;
    } else if (source instanceof QueryResult) {
        list = source.toArray();
    } else if (source instanceof ListDef) {
        source.forEachCurrentValue(item => list.push(item));
    } else {
        const error = { message: 'Provided source input is not ListDef or Array', code: 1 };
        return { array: null, error: error };
    }
    return { array: list, error: null };
};